import React from 'react';
import AppDocuServiceCall from './_Utils/AppDocuServiceCall';
import { notifySomething } from './_Utils/AppDocuCommon';
import LoadingSpinner from '../../comp/gen/LoadingSpinner';
import { Fab, Paper, Stack as MuiStack } from '@mui/material';
import { DataTypeProvider, FilteringState, VirtualTableState } from '@devexpress/dx-react-grid';
import { Grid, TableColumnResizing, TableFilterRow, TableHeaderRow, VirtualTable } from '@devexpress/dx-react-grid-material-ui';
import { applyGridTableFilter } from './_Utils/AppDocuCommon';
import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddServiceActivityDialog from './ServiceActivity_Components/AddServiceActivityDialog';
import { tableColumnExtensions, tableColumns, tableColumnWidths, tableFilteringStateColumnExtensions } from './ServiceActivity_Components/_GridTableProps';
import RowNumTypeProvider from './_Utils/RowNumTypeProvider';
import { DateTypeProvider } from './_Utils/DateTypeProvider';
import ActionsTypeProvider from './ServiceActivity_TypeProviders/ActionsTypeProvider';
import CarTypeProvider from './ServiceActivity_TypeProviders/CarTypeProvider';
import UserTypeProvider from './ServiceActivity_TypeProviders/UserTypeProvider';
import StatusTypeProvider from './ServiceActivity_TypeProviders/StatusTypeProvider';
import EcuTypeTypeProvider from './_Utils/EcuTypeTypeProvider';

const VIRTUAL_PAGE_SIZE = 50;

class AppDocuServiceActivityPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableColumnWidths: tableColumnWidths,
      tableFilters: [],
      localItems: [],
      addDialogIsOpen: false,
      loading: true,
      tableRows: [],
      tableSkip: 0,
      requestedTableSkip: 0,
      requestedTableTake: VIRTUAL_PAGE_SIZE * 2,
      tableTotalRowCount: VIRTUAL_PAGE_SIZE * 2,
      table_total_row_count_ready: false,
    };
    this.getTableRows = this.getTableRows.bind(this);
    // Variabili per memorizzare gli ID dei timeout
    this.filterTimeout = null;
    this.rowsTimeout = null;
    // Bind debounce wrapper
    this.debouncedGetTableRows = this.debouncedGetTableRows.bind(this);
    this.tableRowsChanged = this.tableRowsChanged.bind(this);
  }
  // Funzione debounce per getTableRows
  debouncedGetTableRows(requestedTableSkip, take) {
    if (this.rowsTimeout) {
      clearTimeout(this.rowsTimeout);
    }
    this.rowsTimeout = setTimeout(() => {
      this.getTableRows(requestedTableSkip, take);
    }, 800); // Ritardo di 800 millisecondi
  }
  async componentDidMount() {
    await this.tableRowsChanged()      
  }
  componentWillUnmount() {
    // Cancella i timeout quando il componente viene smontato
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
    if (this.rowsTimeout) {
      clearTimeout(this.rowsTimeout);
    }
  }
  async tableRowsChanged() {
    await this.getTableRows(
      this.state.requestedTableSkip,
      this.state.requestedTableTake
    )
  }  
  async getTableRows(requestedTableSkip, take) {
    console.log("getTableRows", requestedTableSkip, take);
    // Aggiorna lo stato con i parametri richiesti
    await this.setState({ 
      requestedTableSkip: requestedTableSkip,
      requestedTableTake: take,
    });

    // 1. Conta le righe totali
    let totalRowCount = null;
    try {
      const resCount = await AppDocuServiceCall.countServiceActivities(this.state.tableFilters);
      if (!resCount.data || resCount.data.is_valid === false) {
        notifySomething(resCount.data?.message || 'Errore nel conteggio delle attività', 'error');
        return;
      }
      totalRowCount = resCount.data.result;
      await this.setState({
        tableTotalRowCount: totalRowCount,
        table_total_row_count_ready: true,
      });
    } catch (error) {
      notifySomething('Errore nel conteggio delle attività', 'error');
      return;
    }

    // 2. Carica le righe della tabella
    await this.setState({ tableLoading: true });
    let resList;
    try {
      resList = await AppDocuServiceCall.listServiceActivities(requestedTableSkip, take, this.state.tableFilters);
    } catch (error) {
      notifySomething('Errore nel caricamento delle attività', 'error');
      this.setState({ loading: false });
      return;
    }

    if (!resList.data || resList.data.is_valid === false) {
      notifySomething(resList.data?.message || 'Errore nel caricamento delle attività', 'error');
      this.setState({ loading: false });
      return;
    }

    // 3. Numerazione righe e aggiornamento stato
    let i = requestedTableSkip + 1;
    let items = resList.data.result || [];
    items = items.map(row => ({
      ...row,
      row_num: i++
    }));

    await this.setState({
      tableSkip: resList.data.skip, 
      tableRows: items,
      loading: false
    });
  }
  async setTableFilters(filters) {
    this.setState({ tableFilters: filters });
    console.log("setTableFilters", filters);
    // Debounce anche per la query dei dati
    this.debouncedGetTableRows(0, VIRTUAL_PAGE_SIZE);
  }
  render() {
    var height = "calc(100vh - " + this.props.navbarHeight + ")";
    if (!this.state.table_total_row_count_ready) return <LoadingSpinner />
    if (this.state.loading) return <LoadingSpinner />;
    return (
      <Paper>
        <MuiStack direction="row" spacing={1} sx={{ position: 'fixed', bottom: (theme) => theme.spacing(2), right: (theme) => theme.spacing(4), zIndex: 1200 }}>
          <Fab
            onClick={() => this.setState({ addDialogIsOpen: true })}
            variant="extended"
            color="primary"
            aria-label="add" >
            <AddIcon />
          </Fab>         
        </MuiStack>

        <Grid 
          // rows={this.state.localItems}
          rows={this.state.tableRows}
          columns={tableColumns}
          getRowId={row => row.id} 
        >
          <ActionsTypeProvider 
            for={[ "actions" ]} 
            onItemsChange={this.tableRowsChanged} 
          />
          <DateTypeProvider
            for={["created_at", "updated_at"]}           
          />
          <RowNumTypeProvider for={[ "id", "row_num" ]} />
          <StatusTypeProvider 
            for={[ "status" ]} 
            availableFilterOperations={['contains', 'equal']}
          />
          <EcuTypeTypeProvider 
            for={[ "ecu_type" ]} 
            availableFilterOperations={['contains', 'equal']}
          />          
          <CarTypeProvider 
            for={[ "car" ]} 
            availableFilterOperations={['contains']}
          />
          <UserTypeProvider 
            for={["customer_username", "tech_username"]} 
            availableFilterOperations={['contains', 'equal']}
          />
          <DataTypeProvider  
            for={[ "id", "service_activity", "service_issue", "system_type", "system_channel", "system_brand" ]}
            availableFilterOperations={['contains', 'equal']} 
          />

          {/* ********************************************* */}
          {/* ********************************************* */}
          {/* ********************************************* */}

          <VirtualTableState 
            loading={this.state.tableLoading}
            totalRowCount={this.state.tableTotalRowCount} 
            pageSize={VIRTUAL_PAGE_SIZE}
            skip={this.state.tableSkip}
            getRows={this.debouncedGetTableRows} 
          />
          <FilteringState
            filters={this.state.tableFilters}
            onFiltersChange={this.setTableFilters.bind(this)}
            columnExtensions={tableFilteringStateColumnExtensions} />
          <VirtualTable 
            height={height}
            columnExtensions={tableColumnExtensions} />
          <TableColumnResizing
            columnWidths={this.state.tableColumnWidths}
            onColumnWidthsChange={value => this.setState({ tableColumnWidths: value })} />
          <TableHeaderRow contentComponent={props => (<TableHeaderRow.Content {...props} style={{ minHeight: 0, height: 0, paddingTop: 0, paddingBottom: 0, fontSize: 12 }} />)} />
          <TableFilterRow showFilterSelector />
        </Grid>

        <AddServiceActivityDialog
          isOpen={this.state.addDialogIsOpen}
          onClose={() => this.setState({ addDialogIsOpen: false })}
          onItemsChange={this.tableRowsChanged} />
      </Paper>
    );
  }
}

export default AppDocuServiceActivityPage;
